import { useIsMd } from '@/hooks'
import { cn } from '@/lib'

interface ViewportFitProps extends React.ComponentProps<'div'> {
  skipOnMobile?: boolean
  ring?: boolean
}

export const ViewportFitContainer: React.FC<ViewportFitProps> = ({
  className,
  children,
  skipOnMobile,
  ring = true,
  ...rest
}) => {
  const isMd = useIsMd()
  return (
    <div
      className={cn(
        'overflow-hidden flex flex-col rounded-sm bg-white-4  max-h-[calc(100vh-100px)] md:max-h-[calc(100vh-130px)] w-full',
        {
          'max-h-full': !isMd && skipOnMobile,
          'ring-[1px] md:ring-[0.5px] [@media(max-resolution:1.9dppx)]:ring-[1px] ring-white-10': ring,
        },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

interface ViewportContentWrapperProps extends React.ComponentProps<'div'> {}

export const ViewportContentWrapper: React.FC<ViewportContentWrapperProps> = ({ className, children, ...rest }) => {
  return (
    <div
      className={cn('w-full max-h-[inherit] flex flex-col items-center mx-auto overflow-hidden', className)}
      {...rest}
    >
      {children}
    </div>
  )
}

interface ViewportContentProps extends React.ComponentProps<'div'> {}

export const ViewportContent: React.FC<ViewportContentProps> = ({ className, children, ...rest }) => {
  return (
    <div className={cn('relative rounded-sm flex-shrink-1 overflow-auto', className)} {...rest}>
      {children}
    </div>
  )
}
